 import { useState, useEffect } from "react";
 import theme from "../../theme.js";
 
 export default function StepIndicator({title, steps, currentStep}) {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  if (isMobile) {
    return (
      <div style={styles.headerMobile}>
        <h1 style={styles.titleMobile}>{title}</h1>
        <div style={styles.stepIndicatorMobile}>
          {steps.map((step, index) => (
            <div key={step.number} style={styles.stepWrapper}>
              <div style={{ 
                ...styles.stepMobile, 
                ...(currentStep >= step.number && styles.stepActive),
                ...(currentStep !== step.number && { width: "40px" })
              }}>
                <div style={styles.stepNumberMobile}>{step.number}</div>
                {(currentStep === step.number) && (
                <p style={styles.stepLabelMobile}>                  
                  {step.label}
                </p>
              )}  
              </div>
              {index < steps.length - 1 && (
                <div style={{
                  ...styles.stepLineMobile,
                  ...(currentStep > step.number && styles.stepActiveLine),
                  width: "12px",
                }} />
              )}
            </div>
          ))}
        </div>
      </div>
    );
  }

    return (
      
    <div style={styles.header}>
      <div style={styles.container}>
        <h1 style={styles.title}>{title}</h1>
        <div style={styles.stepIndicator}>
            {steps.map((step, index) => (
                <div key={step.number} style={styles.stepWrapper}>
                    <div style={{ ...styles.step, ...(currentStep >= step.number && styles.stepActive) }}>
                    <div style={styles.stepNumber}>{step.number}</div>
                    <p style={styles.stepLabel}>{step.label}</p>
                    </div>
                    {index < steps.length - 1 && <div style={{...styles.stepLine, ...(currentStep > step.number && styles.stepActiveLine)}}></div>}
                </div>
            ))}
        </div>
      </div>
    </div>
  );
}

const styles = {
  headerMobile: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "12px",
    position: "sticky",
    top: 62,
    backgroundColor: theme.colors.bgLight,
    padding: "14px 16px",
    boxShadow: `0 2px 8px ${theme.colors.shadowMedium}`,
    zIndex: "10",
  },
  titleMobile: {
    margin: "0",
    fontSize: "18px",
    fontWeight: "700",
    color: theme.colors.textInverted,
    textAlign: "center",
  },
  stepIndicatorMobile: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0px",
    width: "100%",
  },
  stepMobile: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "4px",
    opacity: 0.5,
    transition: "opacity 0.3s",
  },
  stepNumberMobile: {
    width: "28px",
    height: "28px",
    borderRadius: "50%",
    backgroundColor: theme.colors.primary,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "600",
    fontSize: "12px",
    color: theme.colors.textInverted,
  },
  stepLabelMobile: {
    margin: "0",
    fontSize: "10px",
    fontWeight: "600",
    color: theme.colors.textInverted,
    whiteSpace: "nowrap",
  },
  stepLineMobile: {
    height: "2px",
    backgroundColor: theme.colors.bgDark,
    opacity: 0.3,
    transition: "opacity 0.3s",
    alignSelf: "center",
  },
  header: {
    width: "100%",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "sticky",
    top: 125,
    backgroundColor: theme.colors.bgLight,
    padding: "20px 40px",
    boxShadow: `0 2px 8px ${theme.colors.shadowMedium}`,
    height: "fit-content",
    zIndex: "10",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "100%",
    gap: "16px",
  },
  title: {
    margin: "0",
    fontSize: "32px",
    fontWeight: "700",
    color: theme.colors.textInverted,
    whiteSpace: "nowrap",
    flex: "0 0 auto",
  },
  stepIndicator: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0px",
    width: "100%",
  },
  stepWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "0px",
  },
  step: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
    opacity: 0.5,
    transition: "opacity 0.3s",
  },
  stepActive: {
    opacity: 1,
  },
  stepNumber: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: theme.colors.primary,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "600",
    color: theme.colors.textInverted,
  },
  stepLabel: {
    margin: "0",
    fontSize: "12px",
    fontWeight: "600",
    color: theme.colors.textInverted,
    whiteSpace: "nowrap",
  },
  stepLine: {
    width: "40px",
    height: "2px",
    backgroundColor: theme.colors.bgDark,
    opacity: 0.3,
    transition: "opacity 0.3s",
  },
  stepActiveLine: {
    opacity: 1,
  },
  content: {
    maxWidth: "800px",
    margin: "0 auto",
  },
};